import { createContext } from 'react';
export var SentryContext = createContext(null);
export var SentryConsumer = SentryContext.Consumer;
export var SentryProvider = SentryContext.Provider;
//# sourceMappingURL=SentryProvider.js.map